export const MAINTENANCE_COPY = {
    admin: {
        label: 'Статус сервиса',
        title: 'Ведутся технические работы',
        text: 'Заходите позже. Приносим извинения за временные неудобства.',
    },
    unreachable: {
        label: 'Не удаётся подключиться',
        title: 'Ваш провайдер ограничил доступ к нашему ресурсу :(',
        text: 'Воспользуйтесь списком наших зеркал',
    },
};
